export default __webpack_public_path__ + "static/media/yummy-trans-selected.c5b31cb2.svg";